import { render, staticRenderFns } from "./OrganTree.vue?vue&type=template&id=7823093f&scoped=true"
import script from "./OrganTree.vue?vue&type=script&lang=js"
export * from "./OrganTree.vue?vue&type=script&lang=js"
import style0 from "./OrganTree.vue?vue&type=style&index=0&id=7823093f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823093f",
  null
  
)

export default component.exports